import React from 'react';
import { useWorkspace } from '../context/WorkspaceContext';
import UpgradeWorkspaceModal from './UpgradeWorkspaceModal';

/**
 * GlobalUpgradeModal - Renders the upgrade modal that can be triggered from anywhere
 * via WorkspaceContext.openUpgradeModal()
 */
export const GlobalUpgradeModal = () => {
  const { 
    currentWorkspace, 
    upgradeModalOpen, 
    upgradeTrigger, 
    closeUpgradeModal,
    loadWorkspaces
  } = useWorkspace();

  if (!currentWorkspace) {
    return null;
  }

  return (
    <UpgradeWorkspaceModal
      open={upgradeModalOpen}
      onOpenChange={(open) => {
        if (!open) {
          closeUpgradeModal();
        }
      }}
      workspaceId={currentWorkspace.id}
      workspaceName={currentWorkspace.name}
      trigger={upgradeTrigger}
      onUpgradeComplete={async () => {
        // Refresh workspaces to get updated plan info
        await loadWorkspaces();
      }}
    />
  );
};

export default GlobalUpgradeModal;
